export default {
  name: "auth",
  redirect: { name: "login" },
  children: [
    {
      path: "login",
      name: "login",
      component: () => import("@/modules/auth/views/LoginPage.vue"),
    },
    {
      path: "forgot-password",
      name: "forgot-password",
      component: () => import("@/modules/auth/views/ForgotPasswordPage.vue"),
    },
    {
      path: "register",
      name: "register",
      component: () => import("@/modules/auth/components/RegisterForm.vue"),
    },
  ],
};
